import React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { Spin } from "antd";
import { ILegalViewUpdatePresenter } from "../../presenter/LegalViewUpdatePresenter";
import LegalViewUpdateForm from "../components/LegalViewUpdateForm";

export interface Props extends PageProps {}

export interface State extends ILegalViewUpdatePresenter {}
export default class LegalViewUpdatePage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props, current: 0 };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState(() => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }
  render() {
    const {
      translate,
      legalView,
      legalViewTypes,
      organisations,
      legalViewTypeId,
      setOrganisationId,
      showLegalViewDetailsPage,
      updateLegalView,
      organisationIndexes,
      selectedIndex,
      attachmentContentTypes,
      attachmentTypes,
      attachmentType,
      createAttachment,
      getAttachments,
      setAttachmentType,
      uploadedFile,
      setFileValue,
      updateAttachment,
      attachmentList,
      store,
      selectedOrganisationId,
      canEdit,
      parentGroupList,
      secondGroupList,
      selectedParentGroupIdList,
      selectedSecondGroupIdList,
      setParentGroupId,
      setSecondGroupId,
      selectedIndexes,
      anonimisedUploadedFile,
      setAnonymisedFileValue,
      removeAttachment,
      indexTypeAttributes,
      setAttributesData,
      indexAttributeDataList,
      closeIndexDataModal,
      openIndexDataModal,
      indexDataModalVisible,
      saveAttributeData,
      selectedIndexForAttribute
    } = this.state;
    return (
      <Page {...this.props} className={"page-wrapper"}>
        <Spin spinning={this.state.loaders.legalViewLoader}>
          <LegalViewUpdateForm
            translate={translate}
            legalView={legalView}
            legalViewTypes={legalViewTypes}
            organisations={organisations}
            setOrganisationId={setOrganisationId}
            organisationIndexes={organisationIndexes}
            selectedIndex={selectedIndex}
            onSubmit={updateLegalView}
            showLegalViewDetails={showLegalViewDetailsPage}
            legalViewTypeId={legalViewTypeId}
            attachmentTypes={attachmentTypes}
            attachments={attachmentList}
            attachmentContentTypes={attachmentContentTypes}
            attachmentType={attachmentType}
            createAttachment={createAttachment}
            getAttachments={getAttachments}
            setAttachmentType={setAttachmentType}
            uploadedFile={uploadedFile}
            setFileValue={setFileValue}
            updateAttachment={updateAttachment}
            store={store}
            selectedOrganisationId={selectedOrganisationId}
            canEdit={canEdit}
            parentGroupList={parentGroupList}
            secondGroupList={secondGroupList}
            selectedParentGroupIdList={selectedParentGroupIdList}
            selectedSecondGroupIdList={selectedSecondGroupIdList}
            setParentGroupId={setParentGroupId}
            setSecondGroupId={setSecondGroupId}
            selectedIndexes={selectedIndexes}
            anonimisedUploadedFile={anonimisedUploadedFile}
            setAnonymisedFileValue={setAnonymisedFileValue}
            removeAttachment={removeAttachment}
            indexTypeAttributes={indexTypeAttributes}
            setAttributesData={setAttributesData}
            indexAttributeDataList={indexAttributeDataList}
            closeIndexDataModal={closeIndexDataModal}
            openIndexDataModal={openIndexDataModal}
            indexDataModalVisible={indexDataModalVisible}
            saveAttributeData={saveAttributeData}
            selectedIndexForAttribute={selectedIndexForAttribute}
          />
        </Spin>
      </Page>
    );
  }
}
